import { useEffect, useRef } from 'react';

import {
  Text,
} from 'web-styled';

interface Props {
  html: string;
  size?: string;
  className?: string;
  addRelNoopener?: boolean;
}

export default function HelpText({ html, className, addRelNoopener = true, ...rest }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const onPointerDown = (ev: PointerEvent) => {
      // find the closest anchor from event target up to root
      let el = ev.target as Element | null;
      while (el && el !== root) {
        if (el.tagName === 'A') {
          // stop the mousedown-like behavior that blurs inputs before click fires
          ev.preventDefault();
          // do not stopPropagation: we still want click to be delivered
          return;
        }
        el = el.parentElement;
      }
    };

    // capture phase so it runs before focus/blur side-effects
    root.addEventListener('pointerdown', onPointerDown, { capture: true });

    return () => {
      root.removeEventListener('pointerdown', onPointerDown, { capture: true });
    };
  }, []);

  // optional: ensure every <a target="_blank"> has rel="noopener noreferrer"
  const processedHtml = addRelNoopener
    ? html.replace(/<a\b([^>]*?)\btarget=(["']?)_blank\2([^>]*?)>/gi, (_m, g1, _q, g3) => {
      // if rel already present do not duplicate
      if (/rel=/i.test(g1 + g3)) return `<a${g1}target="_blank"${g3}>`;
      return `<a${g1}target="_blank" rel="noopener noreferrer"${g3}>`;
    })
    : html;

  return (
    <Text
      {...rest}
      ref={ref}
      color="#9EA0A1"
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: processedHtml }}
    />
  )
}
